import { render, staticRenderFns } from "./CardDetailsAssigneesItem.vue?vue&type=template&id=08e3ca92&scoped=true&"
import script from "./CardDetailsAssigneesItem.vue?vue&type=script&lang=js&"
export * from "./CardDetailsAssigneesItem.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailsAssigneesItem.vue?vue&type=style&index=0&id=08e3ca92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3ca92",
  null
  
)

export default component.exports